import { render } from "./TourNotificacoesOverlay.vue?vue&type=template&id=6276bd18"
import script from "./TourNotificacoesOverlay.vue?vue&type=script&lang=js"
export * from "./TourNotificacoesOverlay.vue?vue&type=script&lang=js"

import "./TourNotificacoesOverlay.vue?vue&type=style&index=0&id=6276bd18&lang=css"

import exportComponent from "../../../../../../../usr/local/lib/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__